import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import TradeHistory from "./pages/TradeHistory"; // TradeHistory page
import Dashboard from "./pages/Dashboard"; // Dashboard page
import BillingGrid from "./BillingGrid";
import MarketQuotes from "./components/MarketQuotes";

import Footer from "./Footer";
import PortfolioPage from "./pages/PortfolioPage";
import DecisionReport from "./pages/DecisionReport";
import StrategyManager from "./stratogy/StrategyManager";

const App = () => {
  const location = useLocation();

  // Routes where Sidebar, Header, and Footer should be hidden
  const hideLayoutRoutes = ["/billing"];

  // Check if the current route matches any route in `hideLayoutRoutes`
  const isHiddenLayout = hideLayoutRoutes.includes(location.pathname);

  return (
    <div className="App">
      {/* Conditionally render the Header */}
      {!isHiddenLayout && <Header />}

      <div className="d-flex">
        {/* Conditionally render the Sidebar */}
        {!isHiddenLayout && <Sidebar />}

        <div className="main-content">
          <Routes>
          <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="/" element={<Dashboard />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/trade-history" element={<TradeHistory />} />
            <Route path="/billing" element={<BillingGrid />} />
            <Route path="/analyze-symbol" element={<MarketQuotes />} />
            <Route path="/decision-report" element={<DecisionReport />} />
            <Route path="/strategy-manager" element={<StrategyManager />} />
            {/* Add more routes as needed */}
            </Routes>
        </div>
      </div>

      {/* Footer (if applicable) */}
      {!isHiddenLayout && <Footer />}
    </div>
  );
};

export default App;
